var map = {
	"./about-bg-png-x2.webp": 7521,
	"./about-details.webp": 57229,
	"./about-devices-pngx2.webp": 33216,
	"./about-gradient-pink-turquoise.webp": 20501,
	"./about/logo-agoric.webp": 17458,
	"./about/logo-aib.webp": 33200,
	"./about/logo-alter.webp": 9179,
	"./about/logo-andromeda.webp": 12090,
	"./about/logo-architech.webp": 67600,
	"./about/logo-archway.webp": 50760,
	"./about/logo-axelar.webp": 782,
	"./about/logo-bitcanna.webp": 43443,
	"./about/logo-bonus-block.webp": 68197,
	"./about/logo-crypto-chemistry.webp": 11267,
	"./about/logo-cudos.webp": 28051,
	"./about/logo-decentr.webp": 34011,
	"./about/logo-empowerchain.webp": 32293,
	"./about/logo-gravity-bridge.webp": 15882,
	"./about/logo-inter-protocol.webp": 61689,
	"./about/logo-jackal.webp": 93762,
	"./about/logo-kado.webp": 41310,
	"./about/logo-kelepar.webp": 85746,
	"./about/logo-kusama-kingdom.webp": 76071,
	"./about/logo-landslide.webp": 59765,
	"./about/logo-liquid-finance.webp": 54629,
	"./about/logo-living-opera.webp": 44496,
	"./about/logo-luckyfriday.webp": 89009,
	"./about/logo-nibiru.webp": 31741,
	"./about/logo-phi-labs.webp": 37913,
	"./about/logo-qwoyn-studios.webp": 84827,
	"./about/logo-silvermine-capital.webp": 19521,
	"./about/logo-sky-consulting.webp": 959,
	"./about/logo-synaps.webp": 73622,
	"./about/logo-vidulum.webp": 33507,
	"./about/logo-xavier-capital.webp": 50565,
	"./default-welcome-dialog-bg.webp": 43055,
	"./help/dashboard/Picture1.webp": 52855,
	"./help/dashboard/Picture10.webp": 71730,
	"./help/dashboard/Picture11.webp": 7533,
	"./help/dashboard/Picture12.webp": 29489,
	"./help/dashboard/Picture13.webp": 3713,
	"./help/dashboard/Picture14.webp": 57386,
	"./help/dashboard/Picture15.webp": 31456,
	"./help/dashboard/Picture16.webp": 18778,
	"./help/dashboard/Picture17.webp": 64368,
	"./help/dashboard/Picture18.webp": 75971,
	"./help/dashboard/Picture19.webp": 54683,
	"./help/dashboard/Picture2.webp": 51426,
	"./help/dashboard/Picture20.webp": 14397,
	"./help/dashboard/Picture21.webp": 2559,
	"./help/dashboard/Picture22.webp": 53731,
	"./help/dashboard/Picture23.webp": 50792,
	"./help/dashboard/Picture3.webp": 43583,
	"./help/dashboard/Picture4.webp": 96450,
	"./help/dashboard/Picture5.webp": 28481,
	"./help/dashboard/Picture6.webp": 91243,
	"./help/dashboard/Picture7.webp": 42146,
	"./help/dashboard/Picture8.webp": 58916,
	"./help/dashboard/Picture9.webp": 23424,
	"./help/dashboard/logo-gravitate-white.svg": 1276,
	"./help/dashboard/missing-image-1.png": 18846,
	"./help/dashboard/missing-image-2.png": 33727,
	"./help/dashboard/missing-image-3.png": 95613,
	"./help/dashboard/missing-image-4.png": 34537,
	"./help/dashboard/missing-image-5.png": 56503,
	"./help/dashboard/missing-image-6.png": 32270,
	"./help/dashboard/missing-image-7.png": 86926,
	"./help/pool/Picture1.webp": 20318,
	"./help/pool/Picture10.webp": 36306,
	"./help/pool/Picture11.webp": 82104,
	"./help/pool/Picture12.webp": 43182,
	"./help/pool/Picture13.webp": 21277,
	"./help/pool/Picture14.webp": 44687,
	"./help/pool/Picture15.webp": 75344,
	"./help/pool/Picture16.webp": 76753,
	"./help/pool/Picture17.webp": 50623,
	"./help/pool/Picture18.webp": 20862,
	"./help/pool/Picture19.webp": 24545,
	"./help/pool/Picture2.webp": 54687,
	"./help/pool/Picture20.webp": 6125,
	"./help/pool/Picture21.webp": 64665,
	"./help/pool/Picture22.webp": 34701,
	"./help/pool/Picture23.webp": 93525,
	"./help/pool/Picture24.webp": 12439,
	"./help/pool/Picture25.webp": 31494,
	"./help/pool/Picture26.webp": 17298,
	"./help/pool/Picture27.webp": 30126,
	"./help/pool/Picture28.webp": 70798,
	"./help/pool/Picture29.webp": 8458,
	"./help/pool/Picture3.webp": 33948,
	"./help/pool/Picture4.webp": 32757,
	"./help/pool/Picture5.webp": 19752,
	"./help/pool/Picture6.webp": 56495,
	"./help/pool/Picture7.webp": 75682,
	"./help/pool/Picture8.webp": 81899,
	"./help/pool/Picture9.webp": 37378,
	"./help/trade/Picture1.webp": 95448,
	"./help/trade/Picture10.webp": 45951,
	"./help/trade/Picture11.webp": 15357,
	"./help/trade/Picture12.webp": 10497,
	"./help/trade/Picture13.webp": 77062,
	"./help/trade/Picture14.webp": 21169,
	"./help/trade/Picture15.webp": 20592,
	"./help/trade/Picture16-cancelled.webp": 91687,
	"./help/trade/Picture16.webp": 73561,
	"./help/trade/Picture17.webp": 98031,
	"./help/trade/Picture18.webp": 40388,
	"./help/trade/Picture2.webp": 13861,
	"./help/trade/Picture3.webp": 13006,
	"./help/trade/Picture4.webp": 71656,
	"./help/trade/Picture5.webp": 23305,
	"./help/trade/Picture6.webp": 45617,
	"./help/trade/Picture7.webp": 56532,
	"./help/trade/Picture8.webp": 41817,
	"./help/trade/Picture9.webp": 14628,
	"./help/wallet/Picture1.webp": 95117,
	"./help/wallet/Picture2.webp": 67729,
	"./help/wallet/Picture3.webp": 40527,
	"./help/wallet/Picture4.webp": 80860,
	"./help/wallet/Picture5.webp": 72007,
	"./help/wallet/Picture6.webp": 13722,
	"./loader-ellipse.svg": 84103,
	"./loader.svg": 60355,
	"./sale-bg.png": 99911,
	"./social_001.png": 23945,
	"./trade-bg-mobile-2x.webp": 39418,
	"./trade-bg.webp": 16783,
	"./white-noise-x1.webp": 19504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;